import React from "react"
import { Link } from "gatsby"

import Layout from "../components/common/layout"
import SEO from "../components/common/seo"

const DataLicensePage = () => (
  <Layout pageTitle="Data License">
    <SEO
      title="Data License | Hive Index"
      description="How Hive Index community directory data and statistics may be used, cited, scraped, or used for AI training."
      path="/data-license/"
    />

    <div className="max-w-3xl">
      <p className="text-gray-600 leading-relaxed">
        Hive Index is operated by Top Cheddar LLC. This page describes how you
        may use our community directory, aggregated statistics, and topic
        reports. For general site rules, see our{" "}
        <Link
          to="/terms-and-conditions/"
          className="text-rose-600 hover:underline"
        >
          Terms and Conditions
        </Link>
        .
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        Free to browse
      </h2>
      <p className="text-gray-600 leading-relaxed">
        You may access and browse Hive Index on the web at no charge. This
        includes community listings, topic pages, platform pages, feature
        directories, and statistics reports.
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        Permitted use without permission
      </h2>
      <p className="text-gray-600 leading-relaxed">
        You may do the following without asking us first:
      </p>
      <ul className="mt-3 list-disc pl-6 space-y-2 text-gray-600">
        <li>Link to Hive Index pages</li>
        <li>
          Cite or quote limited statistics in research, news reporting,
          commentary, or academic work (see Attribution below)
        </li>
        <li>Include Hive Index in search engine indexes</li>
        <li>Archive pages for library preservation</li>
      </ul>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">Attribution</h2>
      <p className="text-gray-600 leading-relaxed">
        If you use Hive Index data, statistics, or listings in any published
        work (including articles, reports, presentations, charts, or social
        posts), you must attribute Hive Index. Include the name &quot;Hive
        Index&quot; and a link to thehiveindex.com or, preferably, the specific
        source page you used.
      </p>
      <p className="mt-3 text-gray-600 leading-relaxed">
        Example: Source: <span className="text-gray-800">Hive Index</span> (
        <a
          href="https://thehiveindex.com/topics/startup/stats/"
          className="text-rose-600 hover:underline"
        >
          thehiveindex.com/topics/saas/stats/
        </a>
        )
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">
        Requires prior written permission
      </h2>
      <p className="text-gray-600 leading-relaxed">Contact us before you:</p>
      <ul className="mt-3 list-disc pl-6 space-y-2 text-gray-600">
        <li>
          Scrape, crawl, or systematically download Hive Index content or data
        </li>
        <li>
          Extract, republish, or redistribute our dataset in bulk, including via
          API, database dump, or downloadable dataset
        </li>
        <li>
          Use Hive Index data to train, fine-tune, or evaluate machine learning
          or AI models
        </li>
        <li>
          Create a competing directory or data product substantially derived
          from our listings or statistics
        </li>
      </ul>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">Ownership</h2>
      <p className="text-gray-600 leading-relaxed">
        Community listings, aggregated statistics, and derived reports on Hive
        Index are owned by Top Cheddar LLC and protected by copyright and other
        intellectual property laws, except where third-party content is clearly
        attributed.
      </p>

      <h2 className="mt-8 mb-3 text-xl font-bold text-gray-900">Contact</h2>
      <p className="text-gray-600 leading-relaxed">
        For permission requests or questions about data use, email{" "}
        <a
          href="mailto:contact@thehiveindex.com?subject=Data%20license%20request"
          className="text-rose-600 hover:underline"
        >
          contact@thehiveindex.com
        </a>
        .
      </p>

      <p className="mt-8 text-sm text-gray-500">Last updated: May 2026</p>
    </div>
  </Layout>
)

export default DataLicensePage
